import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=11a0d71b&scoped=true&"
import script from "./Upcoming.vue?vue&type=script&lang=js&"
export * from "./Upcoming.vue?vue&type=script&lang=js&"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=11a0d71b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0d71b",
  null
  
)

export default component.exports